<template>
    <div class="chat-wrap" :class="extendStatus && extendStatus !== null ? 'chat-wrap_extend' : (!extendStatus && extendStatus !== null) ? 'chat-wrap_standart' : extendStatus === null ? '':''">
        <div class="chat-extendSwitcher" @click="switchToExtend()">
            <svg v-if="!extendStatus" style="width:30px;height:30px" viewBox="0 0 24 24">
                <path fill="#a1b7cc" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
            </svg>
            <svg v-if="extendStatus" style="width:30px;height:30px" viewBox="0 0 24 24">
                <path fill="#a1b7cc" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
            </svg>
        </div>
        <div class="chat-block">
            <chat-navigator :extendStatus="extendStatus"></chat-navigator>
        </div>
    </div>
</template>
<script>
import ChatNavigator from "./chat-vertical-widget-navigator"
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
    components: {
        'chat-navigator':ChatNavigator,
        'scrollbar':VuePerfectScrollbar
    },
    data() {
        return {
            extendStatus:null
        }
    },
    methods: {
        switchToExtend() {
            if(this.extendStatus === null)
                this.extendStatus = true;
            else
                this.extendStatus = !this.extendStatus;
        }
    }    
}
</script>
<style lang="less" scoped>
.chat {
    &-wrap {
        display: flex;
        height: calc(100vh - 140px);
        overflow-x: hidden; 
        //overflow-y: scroll;
        overflow: -moz-scrollbars-none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar { 
            display: none; 
        } 
        &_extend {
            position: absolute;
            width: 700px;
            background: #324258;
            right: 0;
            z-index: 5;
            animation: extendIn .7s ease-in;
            animation-fill-mode: forwards;
        }
        &_standart {
            position: absolute;
            width: 400px;
            background: #324258;
            right: 0;
            z-index: 5;
            animation: extendOut .7s ease-in;
            animation-fill-mode: forwards;
        }
    }
    &-extendSwitcher {
        display: flex;
        align-items: center;
        min-width:30px;
        //background: rgba(0,0,0,0.1);
        //box-shadow: 0 0 20px rgba(0,0,0,0.5);
        height: calc(100vh - 140px);
    }
    &-block {
        flex-grow: 1;
    }
}
@keyframes extendIn {
  0% {
    width: 400px;
  }
  100% {
    width: 700px;
  }
}
@keyframes extendOut {
  0% {
    width: 700px;
  }
  100% {
    width: 400px;
  }
}
</style>

